import { TARGET } from "drop-in-ui/utils/configs";

export const isLocal = () => TARGET && TARGET.includes("local");
